import { Text } from '@chakra-ui/react';

import { CompleteIcon } from 'shared-components';

import SectionStartTemplate from '../../templates/sectionStart';

export interface IDispatchProps {
  onLogout: () => void;
}

const CourseConflictInfo = (props: IDispatchProps) => {
  return (
    <SectionStartTemplate
      hideProgress={true}
      onNext={props.onLogout}
      proceedLabel="Log Out"
      section="Thank you for confirming your personal information"
    >
      <CompleteIcon />

      <Text fontSize="lg">You will be notified by email when it's time to resume your CAS application.</Text>
    </SectionStartTemplate>
  );
};

export default CourseConflictInfo;
